module.exports = __webpack_public_path__ + "img/sms.f87a257c.svg";